<template>
  <div class="sp-template">
    <div class="h-title">尾程面单打印</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="conditions" class="header-search__form" size="small" label-width="90px">
            <el-form-item label="仓库">
              <el-select v-model.lazy="conditions.warehouseIds" filterable clearable multiple>
                <el-option v-for="(d, i) in warehouses" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="承运商">
              <el-select v-model.lazy="conditions.carrier" filterable clearable>
                <el-option v-for="(d, i) in carriers" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input v-model="conditions.number" type="textarea" rows="1" placeholder="多个订单号用回车分割"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button v-if="in_configs(40904)" type="primary" size="small" @click="search">搜 索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button v-if="in_configs(40904)" size="small" @click="reset()">清 空</el-button>
            </el-form-item>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="conditions.status" @tab-click="search">
					<el-tab-pane v-if="in_configs(40902)" label="待处理" name="pending"></el-tab-pane>
					<el-tab-pane v-if="in_configs(40903)" label="待打印" name="snapshot"></el-tab-pane>
          <el-tab-pane v-if="in_configs(40903)" label="已打印" name="done"></el-tab-pane>
				</el-tabs>
        <div class="button-groups">
          <el-button size="small" @click="createOrderPop">新建</el-button>
          <el-button size="small" @click="cancelOrder">取消</el-button>
          <template v-if="conditions.status === 'pending'">
            <el-button size="small" @click="rate('uploadOrderForm')">试算</el-button>
          </template>
          <template v-else>
            <el-button v-show="in_configs(40905)" size="small" @click="downloadOrder">合并下载</el-button>
          </template>
          
         
        </div>
      </div>
      <div class="split_statistics">
        <span class="text">已选总箱数：
          <span class="total">{{totalCartonNumber}}</span> 箱</span>
        <span class="text">总重量：
          <span class="total">{{totalCartonWeight}}</span> KG</span>
        <span class="text">打单总重量：
          <span class="total">{{totalLastMileWeight}}</span> KG</span>
      </div>
      <el-table ref="multipleTable" v-loading="loading" :data="tableData" stripe border style="width: 100%" @selection-change="handleSelectionChange" :cell-class-name="cellcb">
        <el-table-column type="selection" width="55" :selectable="selectTable"></el-table-column>
        <el-table-column label="订单号" width="160" prop="orderId"></el-table-column>
        <el-table-column label="仓库" prop="whName" />
        <!-- <el-table-column width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.num">已选{{scope.row.num}}箱</span>
          </template>
        </el-table-column> -->
        
        <!-- <el-table-column v-if="conditions.status == '1'" prop="supplierChannelCode" label="供应商渠道" :formatter="supplierChannelCode"></el-table-column> -->
        <el-table-column prop="totalCarton" width="100" align="center" label="总箱数"></el-table-column>
        <el-table-column prop="totalWeight" width="100" align="center" label="总重量(kg)"></el-table-column>
        <el-table-column prop="volumeWeight" width="100" align="center" label="体积重"></el-table-column>
        <el-table-column prop="product" label="产品"  ></el-table-column>
        <template v-if="conditions.status == 'pending'">
          <el-table-column  prop="fbaWarehouseCode" label="仓码"  ></el-table-column>
          <el-table-column  prop="address.countryCode" label="国家"  ></el-table-column>
          <el-table-column  prop="address.province" label="州/省"  ></el-table-column>
          <el-table-column  prop="address.city" label="城市"  ></el-table-column>
          <el-table-column  prop="address.address" label="地址"  ></el-table-column>
          <el-table-column  prop="address.postCode" label="邮编"  ></el-table-column>
          <el-table-column  prop="error" label="异常信息"  ></el-table-column>
        </template>
        <template v-else>
          <el-table-column prop="trackingNumber" label="跟踪号"></el-table-column>
          <el-table-column prop="lastMileWeight" width="120" align="center" label="打单重量(kg)"></el-table-column>
          <el-table-column prop="totalCharge" label="打单成本"  ></el-table-column>
          <el-table-column prop="startTime" label="打单时间"></el-table-column>
        </template>
        <el-table-column prop="supplierOrderId" label="供应商订单号"></el-table-column>
        <!-- <el-table-column v-if="conditions.status == '1'" label="下载" width="100">
          <template slot-scope="scope">
            <el-button v-if="scope.row.labelContentType != null && !scope.row.deleted  && in_configs(40907)" size="mini" type="text" @click="printLabelConent(scope.row)">
              <i class="el-icon-printer"></i>
            </el-button>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" v-if="conditions.status == 'pending' && in_configs(40910)" @click="editOrder(scope.row)">编辑</el-button>
            <!-- <el-button type="text" size="mini" v-if="conditions.status == 'pending' && in_configs(40909)" @click="splitOrder(scope.$index, scope.row)">拆分</el-button> -->
            <el-button type="text" size="mini" v-else-if="scope.row.ossKey"
              @click="printLabelConent(scope.row)">打印</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="conditions.currentPage" :page-sizes="[10, 20, 50]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
    <!-- 订单拆分 -->
    <el-dialog title="订单拆分" :visible.sync="splitTableVisible" :show-close='false' width="1000px">
      <el-form :model="rowData" size="small" inline :label-width="formLabelWidth">
        <el-form-item label="客户">{{rowData.orgOwner}}</el-form-item>
        <el-form-item label="产品">{{rowData.product}}</el-form-item>
        <el-form-item label="订单号">{{conditions.status == 1 && rowData.orderId != null ? rowData.orderId.split("-")[0] : rowData.orderId}}</el-form-item>
        <el-form-item label="货物箱数">{{rowData.totalCarton}}</el-form-item>
      </el-form>

      <el-table :data="rowData.cartonDetails" @selection-change="handleSelectionCartonChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column property="cartonNumber" label="货箱编号"></el-table-column>
        <el-table-column property="weight" label="重量(kg)"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelSplitOrder()">取 消</el-button>
        <el-button size="small" type="primary" @click="saveSplitOrder()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 上传订单 -->
    <el-dialog title="选择供应商及产品" class="common-select__dialog" :visible.sync="dialogUpLoadVisible" :before-close="emptyForm" @close="rulesForm('uploadOrderForm')" width="30%">
      <el-form :model="uploadOrderForm" size="small" :rules="uploadOrderFormRules" ref="uploadOrderForm">
        <el-form-item label="供应商名称" :label-width="formLabelWidth" prop="channelProvider">
          <el-select v-model="uploadOrderForm.channelProvider" @change="queryChannelProvider">
            <el-option v-for="(c,i) in channelProvider" :key="i" :label="c.name" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品名称" :label-width="formLabelWidth" prop="channelProduct">
          <el-select v-model="uploadOrderForm.channelProduct" filterable @change="queryChannelProduct">
            <el-option v-for="d in channelProduct" :key="d.id" :label="d.name" :value="d.code"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel('uploadOrderForm')">取 消</el-button>
        <el-button size="small" type="primary" @click="beforePlaceOrder('uploadOrderForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 地址错误弹层 -->
    <el-dialog title="错误提示" :visible.sync="errorDataVisible">
      <h4>您的地址有误，请重新核对。以下是可供您参考的信息！</h4>
      <table class="error-table">
        <thead>
          <tr>
            <th>订单号</th>
            <th colspan="4" style="text-align: center;">参考信息</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="errorData && errorData.length > 0" :key="index" v-for="(data, index) in errorData">
            <td>{{data.orderId}}</td>
            <td class="error-table__content">
              <table class="error-table__inner" width="100%">
                <thead>
                  <tr>
                    <th v-if="data.notError">州</th>
                    <th v-if="data.notError">城市</th>
                    <th v-if="data.notError">邮编</th>
                    <th v-if="!data.notError" colspan="4">错误提示消息</th>
                  </tr>
                </thead>
                <tbody v-if="!data.notError">
                  <tr>
                    <td colspan="4">{{data.message}}</td>
                  </tr>
                </tbody>
                <tbody v-for="(msg, index) in data.address" :key="index">
                  <tr>
                    <td v-if="data.notError">{{msg.stateProvinceCode}}</td>
                    <td v-if="data.notError">{{msg.city}}</td>
                    <td v-if="data.notError">{{msg.postalCode}}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </el-dialog>

    <!-- 试算弹框 -->
    <el-dialog title="试算运费" :visible.sync="shisuanVisible" :show-close='false' width="1000px">
        <el-table :data="productData" ref="multipleTable" style="width: 100%"   :header-cell-class-name="cellClass" border >
          <el-table-column prop="supplierChannelName" label="产品"></el-table-column>
          <el-table-column prop="totalCharge" label="总金额">
            <template slot-scope="scope">
              {{ scope.row.success ? scope.row.value.orderCharge.charge : ''}}
            </template>
          </el-table-column>
          <el-table-column label="错误信息" prop="message" />
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button v-if="scope.row.success" size="small" type="primary" @click="placeOrder(scope.row)">下单</el-button>
            </template>
          </el-table-column>
        </el-table>
    </el-dialog>


     <!-- 新建弹框 -->
     <el-dialog title="新建" :visible.sync="createOrderVisible" :show-close='false' width="700px" :append-to-body="true"
        v-dialogDrag>
      
      <el-form  :model="createForm" class="header-search__form" size="small" label-width="90px">
        <el-form-item label="订单号">
          <el-input v-model="createForm.orderIdTxt" type="textarea" rows="2" placeholder="多个订单号用回车分割"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="createOrderVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="createOrderSubmit()">确 定</el-button>
      </div>

    </el-dialog>



  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      createForm:{
        orderIdTxt: '',
        orderIds: []
      },
      createOrderVisible: false,
      productData: [],
      loading: true,
      conditions: {
        warehouseIds: [],
        status: "pending",
        productId: "",
        number: "",
        startDate: "",
        endDate: "",
        currentPage: 1,
        pageSize: 10,
        carrier: ''
      },
      queryForm: {
        warehouseIds: []
      },
      tableData: [],
      dialogUpLoadVisible: false,
      multipleOrder: [],
      channels: [],
      channelProvider: [],
      channelProduct: [],
      formLabelWidth: "120px",
      total: 0,
      uploadOrderForm: {
        channelProduct: "",
        channelProvider: "",
        orderId: '',
        carrier: ''
      },
      uploadOrderFormRules: {
        channelProduct: [
          { required: true, message: "请选择产品", trigger: "change" }
        ],
        channelProvider: [
          { required: true, message: "请选择客户", trigger: "change" }
        ]
      },
      rowData: {
        index: "",
        cartonDetails: [
          {
            cartonNumber: "",
            weight: 0
          }
        ]
      },
      warehouses: [],
      warehouseMap: {},

      newOrders: [],
      splitCartonData: [],
      totalCartonNumber: 0,
      totalCartonWeight: 0,
      totalLastMileWeight: 0,
      tempNumber: 0,
      tempWeight: 0,
      apiOrders: [],
      errorData: [],
      subData: [],
      rowTableIndex: -1,
      errorDataVisible: false,
      splitTableVisible: false,
      shisuanVisible: false,
      carriers: [{name: 'UPS',id: 'UPS'}, {name: 'FEDEX',id: 'FEDEX'}]
    };
  },
  watch: {
    "conditions.status"() {
      this.conditions.currentPage = 1;
      this.query();
      this.totalCartonNumber = 0;
      this.totalCartonWeight = 0;
      this.totalLastMileWeight = 0;
      this.splitCartons = [];
      this.tmepNumber = 0;
      this.tmepWeight = 0;
    }
  },
  components: {},
  created() {
    let _this = this;
    _this.totalCartonNumber = 0;
    _this.totalCartonWeight = 0;
    _this.totalLastMileWeight = 0;
    setTimeout(() => {
      _this.findAllChannle();

      // 仓库加载后加载订单
      _this.queryWarehouseList();

      _this.loading = false;
    }, 500);
  },
  methods: {
    queryWarehouseList() {
      let _this = this;
      _this.$request1
        .get(
          '/warehouse/staff',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          // console.log(res);
          _this.warehouses = res.data;
          _this.warehouses.forEach(a => {
            _this.warehouseMap[a.id] = a.name;
          });

          _this.query();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    selectTable(row, index) {
      if (row.num && row.num === 0) {
        return false;
      } else {
        return true;
      }
    },
    cellcb(row) {
      if (row.row && row.row.deleted) {
        return "myCell";
      }
    },
    //关闭查分订单窗口
    cancelSplitOrder() {
      this.splitTableVisible = false;
      this.rowData = {};
    },
    // 编辑订单
    editOrder(row) {
      let orderId = row.orderId,
        editCarton = true;
      this.$router.push({
        path: "/editorder",
        query: { orderId, editCarton, from: "lastmile" }
      });
    },
    //订单拆分 --- 打开弹层
    splitOrder(index, row) {
      this.rowData = {};
      this.rowData = row;
      if (this.conditions.status == 0) {
        this.splitTableVisible = true;
      }
    },
    //选择箱号拆分
    handleSelectionCartonChange(val) {
      this.splitCartonData = [];
      this.subData = val;
      val.forEach((select, index) => {
        this.splitCartonData.push(select.cartonNumber);
      });
    },
    // 确认--关闭弹层
    saveSplitOrder() {
      this.splitTableVisible = false;
      let orderId = this.rowData.orderId;
      let weight = 0;
      let lastMileWeight = 0;
      this.subData.forEach((val, index) => {
        weight += val.weight;
        lastMileWeight += Math.floor(val.weight);
      });

      if (this.splitCartonData.length == 0 && this.rowData.num) {
        this.$refs.multipleTable.toggleRowSelection(this.rowData, false);
      }

      this.$set(this.rowData, "num", this.splitCartonData.length);
      this.$set(this.rowData, "weight", weight);
      this.$set(this.rowData, "sumLastMileweight", lastMileWeight);
      this.$set(this.rowData, "subData", this.subData);

      this.multipleOrder = [];
      this.newOrders.forEach((data, index) => {
        let multipleOrder = { orderId: "", totalCarton: "", cartonNumbers: [] };

        multipleOrder.orderId = data.orderId;
        multipleOrder.totalCarton = data.totalCarton;

        if (data.subData && data.subData.length > 0) {
          data.subData.forEach((item, index) => {
            multipleOrder.cartonNumbers.push(item.cartonNumber);
          });
        } else {
          data.cartonDetails.forEach((item, index) => {
            multipleOrder.cartonNumbers.push(item.cartonNumber);
          });
        }
        this.multipleOrder.push(multipleOrder);
      });
      this.totalCartonNumber = 0;
      this.totalCartonWeight = 0;
      this.totalLastMileWeight = 0;
      this.newOrders.forEach(item => {
        let data = this.tableData[item.dataIndex];
        if (data.subData && data.subData.length > 0) {
          this.$set(data, "num", data.num);
          this.$set(data, "weight", data.weight);
          this.$set(data, "lastMileweight", data.lastMileweight);
        }
        if (data.num && data.num > 0) {
          this.totalCartonNumber += data.num;
          this.totalCartonWeight += data.weight;
          this.totalLastMileWeight += Math.floor(data.weight);
        }
      });
    },
    reset() {
      this.conditions = {
        warehouseIds: [],
        status: "0",
        productId: "",
        number: "",
        startDate: "",
        endDate: "",
        currentPage: 1,
        pageSize: 10
      };
      this.queryForm = {
        warehouseIds: []
      }
      this.search();
    },
    //搜索
    search() {
      this.conditions.currentPage = 1;
      this.query();
    },
    query() {
      let _this = this;
      _this.conditions.orderIds = [];
      _this.conditions.number.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          _this.conditions.orderIds.push(d);
        }
      });


      this.$request1({
        method: 'post',
        url: '/lastMileExpress/query',
        xhrFields: {
          withCredentials: true
        },
        data: this.conditions
      })
        .then(function(res) {
          if (res.data.success) {
            _this.tableData = res.data.data;
            _this.cartonToWeight = {};
            _this.tableData.forEach((data, index) => {
              _this.$set(data, "dataIndex", index);

              data.cartonDetails.forEach((data1, index) => {
                _this.cartonToWeight[data1.cartonNumber] = data1.weight;
              });
            });
            _this.total = res.data.total;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    addOrder() {
      if (!this.multipleOrder || this.multipleOrder.length == 0) {
        this.$message.error("请选择订单");
        return;
      }
      this.$request1({
        type: 'GET',
        url: '/lastMileExpress/channel',
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          this.channelProvider = response.data;
        })
        .catch(error => {
          console.log(error);
        });
      this.dialogUpLoadVisible = true;
    },
    addOrder2(row) {
      this.dialogUpLoadVisible = true;
    },
    //查询渠道产品
    findAllChannle() {
      let _this = this;
      this.$request1
        .get(
          '/system/channel/all',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          _this.channels = res.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    supplierChannelCode(data) {
      if (data.supplierChannelCode === "UPS-G-CA") {
        return "UPS-Ground-CA";
      } else if (data.supplierChannelCode === "UPS-G-NJ") {
        return "UPS-Ground-NJ";
      } else if (data.supplierChannelCode === "UPS-2") {
        return "UPS大货2号仓";
      } else if (data.supplierChannelCode === "UPS-TEST") {
        return "UPS-TEST";
      }
      return data.supplierChannelCode;
    },
    beforePlaceOrder(uploadOrderForm) {
      let invalidCarton = [];
      this.multipleOrder.forEach((item, index) => {
        item.cartonNumbers.forEach((c, index) => {
          if (this.cartonToWeight[c] > 22.5) {
            invalidCarton.push(c);
          }
        });
      });
      if (invalidCarton.length > 0) {
        this.$msgbox({
          title: "消息",
          message: invalidCarton.join("\n") + " 重量 > 22.5",
          showCancelButton: true,
          confirmButtonText: "继续提交",
          cancelButtonText: "取消"
        }).then(action => {
          this.placeOrder(uploadOrderForm);
        });
      } else {
        this.placeOrder(uploadOrderForm);
      }
    },
    // 下单
    placeOrder(row) {
      this.uploadOrderForm.channelProvider = row.providerId
      this.uploadOrderForm.channelProduct = row.supplierChannelCode
      this.uploadOrderForm.carrier = row.carrier
      this.$request1({
        method: 'post',
        url: '/lastMileExpress/palceOrder',
        data: this.uploadOrderForm,
        withCredentials: true
      })
        .then(response => {
          if (response.data.success) {
            this.$notify({
              title: "成功",
              message: "下单成功",
              type: "success"
            });
            this.uploadOrderForm.orderId = ''
            this.uploadOrderForm.channelProvider = ''
            this.uploadOrderForm.channelProduct = ''
            this.uploadOrderForm.carrier = ''
            this.shisuanVisible = false
            this.query();
          } else {
            this.$notify.error({
              title: "提示",
              message: response.data.message
            })
          }
          
        }).catch(error => {
          this.$message.error("操作失败");
        });
    },
    // 新建尾程订单
    createOrderPop(){
      
      this.createOrderVisible = true
      this.createForm = {
        orderIdTxt: '',
        orderIds: []
      }
    },
    createOrderSubmit(){
      if (!this.createForm.orderIdTxt || this.createForm.orderIdTxt.trim() == '') {
        this.$message.error("请输入订单号");
        return;
      }
      this.createForm.orderIds = [];
      this.createForm.orderIdTxt.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          this.createForm.orderIds.push(d);
        }
      });
      if (this.createForm.orderIds.length == 0) {
        this.$message.error("请输入订单号");
        return;
      }

      let _this = this
      this.$request1({
        method: 'post',
        url: '/lastMileExpress/create',
        data: this.createForm.orderIds,
        withCredentials: true
      }).then(response => {
          if(response.data.success){
            _this.$message.success("新建成功");
            _this.query()
            _this.createOrderVisible = false
          }else{
            _this.$message.error(response.data.message);
          }
        }).catch(error => {
          console.log(error)
          this.$message.error("操作失败");
        })
    },
    cancelOrder(){
      if (!this.multipleOrder || this.multipleOrder.length == 0) {
        this.$message.error("请选择一个订单");
        return;
      }

      let orderIds = [];
      for (var i = 0; i < this.multipleOrder.length; i++) {
        orderIds.push(this.multipleOrder[i].orderId);
      }
      

      let _this = this
      this.$confirm("确定要取消订单", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        _this.$request1({
          method: 'post',
          url: '/lastMileExpress/cancel',
          data: orderIds,
          withCredentials: true
        }).then(response => {
          if(response.data.success){
            _this.$message.success("操作成功");
            _this.query()
          }else{
            _this.$message.error(response.data.message);
          }
        })
      })

    },
    // 比价
    rate() {
      if (!this.multipleOrder || this.multipleOrder.length == 0) {
        this.$message.error("请选择一个订单");
        return;
      }else if(this.multipleOrder.length > 1){
        this.$message.error("一次只能选择一个订单");
        return;
      }
      let _this = this
      this.uploadOrderForm.orderId = this.multipleOrder[0].orderId
      this.$request1({
        method: 'post',
        url: '/lastMileExpress/rate',
        data: this.uploadOrderForm,
        withCredentials: true
      }).then(response => {
          if(response.data.success){
            _this.shisuanVisible = true;
            _this.productData = response.data.data;
           
          }
        }).catch(error => {
          console.log(error)
          this.$message.error("操作失败");
        })
    },
    cellClass(row) {
      if (row.columnIndex === 0) {
        return "DisabledSelection";
      }
    },
    //下载面单
    downloadOrder() {
      let _this = this;
      if (!this.multipleOrder || this.multipleOrder.length == 0) {
        this.$message.error("请选择一个订单");
        return;
      }
      let orderIds = [];
      for (var i = 0; i < this.multipleOrder.length; i++) {
        orderIds.push(this.multipleOrder[i].orderId);
      }
      this.$request1({
        method: 'post',
        url: '/lastMileExpress/download',
        data: orderIds,
        withCredentials: true
      }).then(response => {
        if(response.data.success){
          window.open(response.data.data)
          _this.query()
        }else{
          this.$message.error(response.data.message);
        }
      })
    },
    printLabelConent(row) {
      this.$request1({
        method: 'post',
        url: '/lastMileExpress/download',
        data: [row.orderId],
        withCredentials: true
      }).then(response => {
        if(response.data.success){
          window.open(response.data.data)
          this.query()
        }else{
          this.$message.error(response.data.message);
        }
      })
    },

    //查找供应商
    queryChannelProvider() {
      this.uploadOrderForm.channelProduct = "";
      this.queryChannelProduct();
    },
    //查找供应商的产品
    queryChannelProduct(channelProvider) {
      this.$request1({
        type: 'GET',
        url: '/lastMileExpress/product',
        params: {
          channelProvider: this.uploadOrderForm.channelProvider
        },
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          this.channelProduct = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    emptyForm() {
      this.uploadOrderForm.channelProduct = "";
      this.uploadOrderForm.channelProvider = "";
      this.dialogUpLoadVisible = false;
    },
    cancel(formRule) {
      this.$refs[formRule].clearValidate();
      this.emptyForm();
    },
    rulesForm(formRule) {
      this.$refs[formRule].clearValidate();
    },
    //多选按钮
    handleSelectionChange(val) {
      this.newOrders = val;
      this.multipleOrder = [];
      this.apiOrders = [];
      val.forEach((data, index) => {
        if (!data.deleted) {
          if (this.conditions.status == "0") {
            let multipleOrder = {
              apiOrderId: "",
              orderId: "",
              totalCarton: "",
              cartonNumbers: []
            };
            multipleOrder.apiOrderId = data.apiOrderId;
            multipleOrder.orderId = data.orderId;
            multipleOrder.totalCarton = data.totalCarton;

            if (data.subData && data.subData.length > 0 && data.num > 0) {
              data.subData.forEach((item, index) => {
                multipleOrder.cartonNumbers.push(item.cartonNumber);
              });
            } else {
              data.cartonDetails.forEach((item, index) => {
                multipleOrder.cartonNumbers.push(item.cartonNumber);
              });
            }
            this.multipleOrder.push(multipleOrder);
          } else {
            let apiOrder = {
              orderId: "",
              apiOrderId: "",
              labelContentType: ""
            };
            apiOrder.orderId = data.orderId;
            apiOrder.apiOrderId = data.apiOrderId;
            apiOrder.labelContentType = data.labelContentType;
            this.apiOrders.push(apiOrder);

            var count = 0;
            for (var i = 0; i < data.orderId.length; i++) {
              if (data.orderId.charAt(i) == "-".charAt(0)) {
                count++;
              }
            }
            var orderId = data.orderId;
            var seq = 0;
            if (count == 1 || count > 3) {
              var index = orderId.lastIndexOf("-");
              orderId = data.orderId.substring(0, index);
            }

            let orderIds = [];
            this.multipleOrder.forEach((order, index) => {
              orderIds.push(order.orderId);
            });
            this.tableData.forEach((item, index) => {
              if (
                !orderIds.includes(item.orderId) &&
                item.orderId.indexOf(orderId) != -1 &&
                !item.deleted
              ) {
                let multipleOrder = {
                  apiOrderId: "",
                  orderId: "",
                  totalCarton: "",
                  cartonNumbers: []
                };
                orderIds.push(item.orderId);
                multipleOrder.apiOrderId = item.apiOrderId;
                multipleOrder.orderId = item.orderId;
                multipleOrder.totalCarton = item.totalCarton;
                item.cartonDetails.forEach((item, index) => {
                  multipleOrder.cartonNumbers.push(item.cartonNumber);
                });
                this.multipleOrder.push(multipleOrder);
              }
            });
          }
        }
      });

      this.totalCartonNumber = 0;
      this.totalCartonWeight = 0;
      this.totalLastMileWeight = 0;

      this.tableData.forEach((item, index) => {
        if (val.indexOf(item) == -1) {
          this.$set(item, "num", 0);
          this.$set(item, "weight", 0);
        }
      });

      val.forEach(item => {
        if (!item.deleted) {
          let data = this.tableData[item.dataIndex];
          if (data.subData && data.subData.length > 0 && data.num > 0) {
            this.$set(data, "num", data.num);
            this.$set(data, "weight", data.weight);
            // this.$set(data, "sumLastMileweight", Math.floor(data.weight));
          } else {
            this.$set(data, "num", item.totalCarton);
            this.$set(data, "weight", item.totalWeight);
            this.$set(data, "sumLastMileweight", item.lastMileWeight);

            //this.$set(data, "sumLastMileweight", item.sumLastMileweight);
          }

          if (data.num && data.num > 0) {
            this.totalCartonNumber += data.num;
            this.totalCartonWeight += data.weight;
            this.totalLastMileWeight += data.sumLastMileweight;
          } else {
            this.totalCartonNumber += data.totalCarton;
            this.totalCartonWeight += data.totalWeight;
            this.totalLastMileWeight += data.sumLastMileweight;
          }
        }
      });
    },
    // 更尾程为完成状态
    updateLastMileLabelAccomplish() {
      if (!this.multipleOrder || this.multipleOrder.length == 0) {
        this.$message.error("请选择订单");
        return;
      }

      this.$confirm("请仔细核对，完成后无法再下尾程面单", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let orderIds = [];
          this.multipleOrder.forEach((item, index) => {
            var count = 0;
            for (var i = 0; i < item.orderId.length; i++) {
              if (item.orderId.charAt(i) == "-".charAt(0)) {
                count++;
              }
            }
            var id = item.orderId;
            if (count == 1 || count > 3) {
              var index = id.lastIndexOf("-");
              id = item.orderId.substring(0, index);
            }
            orderIds.push(id);
          });
          this.$request1({
            method: 'post',
            url: '/lastMileExpress/update',
            params: {
              orderIds: orderIds.toString()
            },
            withCredentials: true
          })
            .then(response => {
              if (response.data.success) {
                this.$notify({
                  title: "成功",
                  message: "修改成功",
                  type: "success"
                });
              } else {
                this.$notify({
                  title: "失败",
                  message: response.data.message,
                  type: "error"
                });
              }
              this.query();
            })
            .catch(error => {
              console.log(error);
              this.$message.error("操作失败");
            });
        })
        .catch(() => {});
    },
    lastMileLabelStatus(row) {
      if (row.labelContentType == null) {
        return "无打印";
      } else if (row.printLabel) {
        return "已打印";
      } else {
        return "未打印";
      }
    },
    //分页
    handleSizeChange(val) {
      this.conditions.pageSize = val;
      this.query();
    },
    handleCurrentChange(val) {
      this.conditions.currentPage = val;
      this.query();
    }
  }
};
</script>

<style lang="scss">
.error-table {
  position: relative;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 100%;
  font-size: 14px;
  color: #606266;
  tr,
  th {
    background-color: #fff;
  }
  td,
  th {
    padding: 12px;
    min-width: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-overflow: ellipsis;
    vertical-align: middle;
    position: relative;
    border: 1px solid #ebeef5;
  }
  th {
    white-space: nowrap;
    overflow: hidden;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-align: left;
  }
  .error-table__content {
    padding: 0;
    .error-table__inner {
      td,
      th {
        border-top: none;
        border-left: none;
        border-right: none;
      }
      th {
        background-color: #fafafa;
      }
      tbody:last-child tr td {
        border-bottom: none;
      }
      tr :nth-child(2) {
        border-left: 1px solid #ebeef5;
        border-right: 1px solid #ebeef5;
      }
    }
  }
}
.split_statistics {
  margin-bottom: 10px;
  font-size: 14px;
  color: #606266;
  height: 32px;
  line-height: 32px;
  .text {
    margin-right: 20px;
    .total {
      // color: #3c8dbc;
      font-weight: 600;
    }
  }
}

.slipt-flag {
  position: absolute;
  float: left;
  top: 12px;
  right: 12px;
}
.myCell .el-checkbox {
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/lastmileexpress.vue